import ReducerCreator from '../registerReducer';
import { buildStoreItem } from '../storeItemBuilder';
import { AlarmEmailDTO } from '../../models';
import { StoreItem, DispatchEvent } from '../Store';
import * as AE from './alarmEmail.constants';
import { APPLICATION_DISCONNECTED } from '../constants.index';

const r = new ReducerCreator<AlarmEmailDTO>()
    .register<AlarmEmailDTO[]>(AE.ALARM_EMAIL_LOAD, (AE, payload) => {
        const newAE = new StoreItem<AlarmEmailDTO>();
        newAE.isLoading = true;
        return newAE;
    })
    .register<AlarmEmailDTO[]>(AE.ALARM_EMAIL_LOAD_SUCCESS, (AE, payload) => {
        return buildStoreItem(payload);
    })
    .register<string>(APPLICATION_DISCONNECTED, (HSC, payload) => {
        const newHSC = new StoreItem<AlarmEmailDTO>();
        return newHSC;
    });

    /*
    .register<string>(AE.ALARM_EMAIL_DELETE_SUCCESS, (HSC, payload) => {
        let newAE = angular.copy(HSC);
        let { dictionary } = newAE;
        delete (dictionary[payload]);
        return newAE;
    })
    .register<AlarmEmailDTO>(AE.ALARM_EMAIL_DELETE, (HSC, payload) => {
        let newAE = angular.copy(HSC);
        newAE.isLoading = true;
        return newAE;
    })
    .register<AlarmEmailDTO>(AE.ALARM_EMAIL_UPDATE, (HSC, payload) => {
        let newAE = angular.copy(HSC);
        newAE.isLoading = true;
        return newAE;
    })
    .register<AlarmEmailDTO>(AE.ALARM_EMAIL_UPDATE_SUCCESS, (HSC, payload) => {
        let newAE = angular.copy(HSC);
        let { dictionary } = newAE;
        dictionary[payload.guid] = payload;
        newAE.isLoaded = true;
        newAE.isLoading = false;
        return newAE;
    });*/

export function alarmEmailsReducer(
    state: StoreItem<AlarmEmailDTO> = new StoreItem<AlarmEmailDTO>(),
    action: DispatchEvent<any>
) {
    return r.reduce(state, action);
}